import MIT from "../images/institutions/logo/MIT.png";
import machine from "../images/institutions/mit/machine.png";
import circuit from "../images/institutions/mit/circuit.png";
import biology from "../images/institutions/mit/biology.png";

export const MitData = [
  {
    id: 1,
    title: "Machine Learning with Python: from Linear Models to Deep Learning",
    logo: MIT,
    img: machine,
    path: "/MitCourseOne",
  },
  {
    id: 2,
    title: "Circuits and Electronics 1: Basic Circuit Analysis",
    logo: MIT,
    img: circuit,
  },
  {
    id: 3,
    title: "Introduction to Biology - The Secret of Life",
    logo: MIT,
    img: biology,
  },
];
